<template>
    <div>
        <el-dialog  :center="true" :close-on-click-modal="false" title="审批意见" :visible.sync="rejectDialogShow"  @close="rejectDialogShowClr" width="70%">
            <div>驳回原因:
                <div style="position: absolute; color: #F56C6C; width: 1px; height: 1px;z-index: 111111; margin-left: -10px;margin-top: -16px;">*</div>
            </div>


            <el-checkbox-group v-model="checkedCitiesList" @change="handleCheckedCitiesChange" style="display: flex; flex-wrap: wrap;padding-left: 45px;">
                <el-checkbox v-for="(itme,index) in citiesList" :label="itme.name + itme.values" :key="index" style="width: 40%; margin-top: 20px;"> {{ itme.name }} {{ itme.values }} </el-checkbox>
            </el-checkbox-group>


            <div style="display: flex;margin-top: 20px;">
                <div>备注：</div>
                <div style=" width: 90%;">
                    <el-input  type="textarea"  placeholder="请输入内容"  v-model="textarea"  maxlength="30"  show-word-limit :autosize="{ minRows: 6, maxRows: 6 }" > </el-input>
                </div>
            </div>


            <span slot="footer" class="dialog-footer">
                <div style="text-align: end;">
                    <el-button size="small" type="primary" @click="closeEditDialogSubt">确认</el-button>
                    <el-button size="small"  @click="rejectDialogShowClr">关闭</el-button>
                </div>
            </span>
        </el-dialog>
    </div>
</template>


<script>
import axios from "axios";
import apiBaseUrl from "../../config/api";
export default {
    props: {
        rowOrder: {
          type: Object,
          default: {}
        },
    },
    data(){
        return{
            rejectDialogShow:true,
            checkedCitiesList:[],

            citiesList:[
                { name: '学生姓名: ' , values: '' },
                { name: '学生年级: ', values: '' },
                { name: '学生性别: ', values: '' },
                { name: '家庭住址: ' , values: '' },
                { name: '家长电话: ' , values: '' },
                { name: '课程类别: ', values: '' },
                { name: '上课类型: ', values: '' },
                { name: '线上诊断教师: ', values: '' },
                { name: '线上诊断时间: ', values: '' },
                { name: '线下诊断教师: ', values: '' },
                { name: '线下诊断时间: ', values: '' },
                { name: '是否线下预约: ', values: '' },
                { name: '备注: ', values: '' },
                { name: '订单状态: ', values: '' },
                { name: '是否交定金：', values: '' },
                { name: '是否续费: ', values: '' },
                { name: '诊断报告', values: '' },
            ],


            textarea:'',

            customerId:'',
            order:{},



            checkedCitiesListString:'',
        }
    },

    mounted(){

    },

    methods:{

        init (customerId) {
            this.customerId = customerId;
            axios.get(`${apiBaseUrl}/orderCustomerAudit/details/${customerId}`,{  headers:{'authorization': sessionStorage.getItem('tokenInfo') }}) .then(res => {
                if (res.data.code === 200) {
                    this.order.classHour = res.data.data.classHour
                    this.order.familyHour = res.data.data.familyHour

                    this.order.orderStatus = res.data.data.orderStatus
                    this.order.teacherIdOnline = res.data.data.onlineTeacherName
                    this.order.teacherIdOffline = res.data.data.offlineTeacherName
                    if (res.data.data.onlineTime !== null) {
                    this.order.onlineTime = JSON.parse(res.data.data.onlineTime)
                    }
                    if (res.data.data.offlineTime !== null) {
                    this.order.offlineTime = JSON.parse(res.data.data.offlineTime)
                    }
                    this.order.customerIspay = res.data.data.customerIspay + "";
                    this.order.isRenew = res.data.data.isRenew
                    this.order.customerIsallpay =
                    res.data.data.customerIsallpay + "";
                    this.order.customerAllpaymoney =
                    res.data.data.customerAllpaymoney;
                    this.order.customerAllpaytime =
                    res.data.data.customerAllpaytime;
                    this.order.onlineStatus = res.data.data.onlineStatus
                    this.order.offlineStatus = res.data.data.offlineStatus
                    this.order.remarks = res.data.data.remarks
                    this.order.parentPhoneNumber = res.data.data.parentPhoneNumber;
                    this.order.gradeIdArrToStr = res.data.data.gradeIdArrToStr;
                    this.order.teacherName = res.data.data.userName;
                    this.order.classType = res.data.data.classType;
                    this.order.categoryIdArrToStr =
                    res.data.data.categoryIdArrToStr;
                    this.order.studentName = res.data.data.customerStudent;
                    this.order.sex = res.data.data.sex;
                    this.order.grade = res.data.data.gradeIdArr2;
                    this.order.courseCategoryId = res.data.data.categoryIdArr2;
                    this.order.address = res.data.data.address;
                    this.order.customerPaytime = res.data.data.customerPaytime;
                    this.order.teacherId = res.data.data.customerTeacherid;
                    // this.order.startTime = JSON.parse(res.data.data.startTime);
                    // this.order.startTimeDay = this.order.startTime[0];
                    // this.order.startTimeHour = this.order.startTime[1];

                    this.order.customerPaymoney = res.data.data.customerPaymoney;

                    this.order.payType = res.data.data.payType;
                    this.order.payType2 = res.data.data.payType2;
                    this.order.payAllType2 = res.data.data.payAllType2;

                    this.order.payAlltype = res.data.data.payAlltype;
                    this.order.stages = JSON.parse(res.data.data.stages)
                    this.order.renew = JSON.parse(res.data.data.renew)



                    this.citiesList = [
                        { name: '学生姓名: ', values: this.order.studentName },
                        { name: '学生年级: ', values: this.order.gradeIdArrToStr },
                        { name: '学生性别: ', values: this.order.sex === '1' ? '男' : this.order.sex === '2' ? '女' : '' },
                        { name: '家庭住址: ', values: this.order.address },
                        { name: '家长电话: ', values: this.order.parentPhoneNumber },
                        { name: '课程类别: ', values: this.order.categoryIdArrToStr },
                        { name: '上课类型: ', values: this.order.classType === 1 ? '规划' : this.order.classType === 2 ? '线下' : this.order.classType === 3 ? '纯补课' : '' },
                        { name: '线上诊断教师: ', values: this.order.teacherIdOnline },
                        { name: '线上诊断时间: ', values: this.order.onlineTime[0] + this.order.onlineTime[1] + this.order.onlineTime[2] },
                        { name: '线下诊断教师: ', values: this.order.teacherIdOffline },
                        { name: '线下诊断时间: ', values: this.order.offlineTime[0] + this.order.offlineTime[1] + this.order.offlineTime[2] },
                        { name: '是否线下预约: ', values: this.order.offlineStatus === '1' ? '是' : '否'},
                        { name: '备注: ', values: this.order.remarks },
                        { name: '订单状态: ', values:  this.order.orderStatus === '1' ? '已成单' : '已关闭' },
                        { name: '是否交定金：: ', values: this.order.customerIspay === '1' ? '是' : '否' },
                        { name: '是否续费: ', values: this.order.isRenew === '1' ? '是' : '否' },
                        { name: '诊断报告'},
                    ]


                } else {
                    this.$message({ message: res.data.message,  type: "error"});
                }
            });
        },


        closeEditDialogSubt(){
          axios.post(`${ apiBaseUrl }/orderCustomerAudit/audit`, { auditStatus: 1, id: this.rowOrder.id, rejectCause: this.checkedCitiesListString, remark: this.textarea }, {headers:{'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
              if (res.data.code === 200) {
                  this.$message({  message: res.data.message,  type: "success"  });
                  this.$emit('handleEventBusSbut', false)
              }else{
                this.$message({  message: res.data.message,  type: "error"  });
              }
          })
        },

        rejectDialogShowClr(){
            this.$emit('handleEventBus', false)
        },


        handleCheckedCitiesChange(value){
            this.checkedCitiesListString = value.join(',')
            console.log(this.checkedCitiesListString)
        },

    }

}
</script>



<style scoped lang="less">

</style>



// WEBPACK FOOTER //
// src/ApprovalManagement/rejectDialog.vue